module.exports = __webpack_public_path__ + "img/social_twitter.101d09cd.svg";